import setSuggestedContacts from './setSuggestedContacts';
import datapoints from '../datapoints';
import AtMentionsViewState from '../store/schema/AtMentionsViewState';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { lazyFindReadWriteRecipient } from 'owa-readwrite-recipient-well';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';

export default createLegacyActionWithDatapoint(
    'findReadWriteRecipient',
    datapoints.MentionsFindPeople
)(async function findReadWriteRecipient(
    viewState: AtMentionsViewState,
    queryString: string,
    searchDirectory: boolean,
    currentWellContents?: ReadWriteRecipientViewState[]
): Promise<void> {
    let datapoint = returnTopExecutingActionDatapoint();
    viewState.queryString = queryString;
    if (!queryString) {
        setSuggestedContacts(viewState, currentWellContents);
        datapoint.addCustomData({ zeroState: true.toString() });
    } else {
        await lazyFindReadWriteRecipient.importAndExecute(
            viewState,
            queryString,
            searchDirectory,
            false /*resolveIfSingle*/,
            null /*recipentsToExclude*/,
            currentWellContents,
            true /*searchCacheFirstOverride*/
        );
        const sameQueryString = viewState.queryString.trim() == queryString;
        if (sameQueryString) {
            viewState.selectedRecipientIndex = 0;
        }
        datapoint = returnTopExecutingActionDatapoint();
        datapoint.addCustomData({
            zeroState: false.toString(),
            sameQueryString: sameQueryString.toString(),
            searchDirectory: searchDirectory.toString(),
        });

        return Promise.resolve();
    }

    return Promise.resolve();
});
